import { IconNewTab, IconQAndA, IconQAndASolid } from "@flixbus/honeycomb-icons-react";
import { NavLink } from "react-router-dom";
import { Feature, hasUserPermission } from "../../../../auth";
import { commonPathnames, mpcPathnames, mpoPathnames, musPathnames } from "../../../../helper";
import formatMessage from "../../../translationProvider/helpers/formatMessage/formatMessage";
import App from "../../types";
import { HelpMenuItem } from "../types";

const getHelpMenuItems = (app: App, isUsedInDropdown: boolean) => {
  const pathnames = app === App.MPC ? mpcPathnames : app === App.MPO ? mpoPathnames : musPathnames;

  const items: Array<HelpMenuItem> = [
    {
      key: "faq",
      InlineIcon: isUsedInDropdown ? { regular: IconQAndA, active: IconQAndASolid } : IconQAndA,
      href: app === App.MPO ? undefined : pathnames.faq,
      to: app === App.MPO ? pathnames.faq : undefined,
      RouterLink: app === App.MPO ? NavLink : undefined,
      target: "_blank",
      shouldCloseDialog: isUsedInDropdown ? undefined : true,
      text: "FAQ",
    },
  ];

  if (hasUserPermission(Feature.USER_HAS_SERVICEDESK_ACCESS)) {
    items.push(
      {
        key: "service-desk",
        InlineIcon: IconNewTab,
        href: commonPathnames.serviceDeskReportProblem,
        target: "_blank",
        shouldCloseDialog: isUsedInDropdown ? undefined : true,
        text: formatMessage("navigation.reportProblem"),
      },
      {
        key: "service-desk-business",
        InlineIcon: IconNewTab,
        href: commonPathnames.serviceDeskPlatformBusiness,
        target: "_blank",
        shouldCloseDialog: isUsedInDropdown ? undefined : true,
        text: "Contact Business Team",
      }
    );
  }

  return items;
};

export default getHelpMenuItems;
